import { render, staticRenderFns } from "./NotificationRetailerGroup.vue?vue&type=template&id=fd524362&scoped=true&"
import script from "./NotificationRetailerGroup.vue?vue&type=script&lang=ts&"
export * from "./NotificationRetailerGroup.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationRetailerGroup.vue?vue&type=style&index=0&id=fd524362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd524362",
  null
  
)

export default component.exports